import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initRum } from "./telemetry/rum";
// Fire-and-forget so telemetry can never block first paint.
initRum();
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(_jsx(App, {}));
